module.exports = __webpack_public_path__ + "media/components/assets/hero_images_02-c7ebc97d27b2093391ea71c85e315f07.png";